import { useRef } from 'react';
import { useCookies } from 'react-cookie';
import { DEFAULT_COOKIE_OPTIONS } from 'utils/cookies';

const DEFAULT_COOKIE_STATE = {
  ...DEFAULT_COOKIE_OPTIONS,
  maxAge: 7 * 24 * 60 * 60, // 7 days in seconds
};

function useCookieState(key, initialValue = '') {
  const [cookies, setCookie] = useCookies([key], initialValue);
  const cookieValue = cookies[key];

  if (key === 'filters') delete DEFAULT_COOKIE_STATE.maxAge;

  const prevCookieValue = useRef(cookieValue);

  function handleCookieChange(value) {
    const prevValue = prevCookieValue.current;
    if (JSON.stringify(value) !== JSON.stringify(prevValue)) {
      setCookie(key, value, DEFAULT_COOKIE_STATE);
      prevCookieValue.current = value;
    }
  }

  return [handleCookieChange];
}

export { useCookieState };
